export default class AdminLabs {
    axiosIns = null
    jwtConfig = null
  
    constructor(axiosIns, jwtConfig) {
      this.axiosIns = axiosIns;
      this.jwtConfig = jwtConfig;
    }
  
    list(params) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminLabsRoute}`, {
        params
      })
    }
  
    fetch(id) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminLabsRoute}/${id}`, {})
    }
  
    export(params) {
      return this.axiosIns.get(`${this.jwtConfig.main.adminLabsRoute}/export/all`, {
        params,
        responseType: "blob"
      })
    }
  
    create(payload = {}) {
      return this.axiosIns.post(`${this.jwtConfig.main.adminLabsRoute}`, payload)
    }
  
    update(id, payload = {}) {
      return this.axiosIns.put(`${this.jwtConfig.main.adminLabsRoute}/${id}`, payload, {})
    }

    approve(id) {
      return this.axiosIns.put(`${this.jwtConfig.main.adminLabsRoute}/${id}/approve`, {})
    }
  
    decline(id) {
      return this.axiosIns.put(`${this.jwtConfig.main.adminLabsRoute}/${id}/decline`, {})
    }
  
    delete(id) {
      return this.axiosIns.delete(`${this.jwtConfig.main.adminLabsRoute}/${id}`, {})
    }
}
